import { Trash2 } from 'lucide-react'
import './node-delete-popup.css'

interface NodeDeletePopupProps {
	position: { x: number; y: number }
	onDelete: () => void
	onClose: () => void
}

export function NodeDeletePopup({ position, onDelete }: NodeDeletePopupProps) {
	return (
		<div
			className="node-delete-popup"
			style={{
				left: position.x,
				top: position.y - 40,
			}}
		>
			<button
				onClick={(e) => {
					e.stopPropagation()
					onDelete()
				}}
				onMouseDown={(e) => {
					e.stopPropagation()
				}}
				onContextMenu={(e) => e.preventDefault()}
				className="canvas-popup-button"
				data-variant="delete"
				title="Delete node"
			>
				<Trash2 size={18} className="canvas-popup-button-icon" />
			</button>
		</div>
	)
}
